import { useState, useEffect, useContext } from 'react'
import UserApi from '../../../api/UserApi';
import Payment from '../../../util/Payment';
import UserContext from '../../../context/UserContext';

const MIN_CHARGE_POINT = 5000;
const DEFAULT_CHARGE_POINT = 10000;
const MAGIC_NUMBER = 111222333444;

const CHARGE_OPTIONS = [
    { label: '1000', value: 1000 },
    { label: '2000', value: 2000 },
    { label: '5000', value: 5000 },
    { label: '10000', value: 10000 },
    { label: '20000', value: 20000 },
    { label: '50000', value: 50000 },
]

const ChargePoint = () => {
    const { user, updateUserInfo } = useContext(UserContext);
    const [selectedChargeOption, setSelectedChargeOption] = useState(CHARGE_OPTIONS[0]);


    const handleChargeOptionChange = (e) => {
        setSelectedChargeOption(CHARGE_OPTIONS.find(option => option.value === Number(e.target.value)));
    }

    const handleChargeBtn = () => {
        const payUser = {
            userEmail : user.userEmail,
            userNm : user.userNm,
            userPhone : user.userPhone,
        }
        
        const amount = Number(selectedChargeOption.value);

        if (amount !== MAGIC_NUMBER && (amount < MIN_CHARGE_POINT || amount % 1000 !== 0)) {
            return alert("충전 불가능한 금액입니다.")
        }

        const data = {
            prodId : '10000',
            prodTitle : '포인트 충전',
            prodDisc : 0,
            prodPrice : selectedChargeOption.value,
        };

        Payment.openPaymentPage(data, payUser, '/point/charge/complete', updateUserInfo);
    }

    return (
        <>
            <div class="points-summary">
                <div class="points-container">
                    <div class="current-points">
                        <i class="fas fa-coins"></i>
                        <span>잔여포인트</span>
                        <strong>{user.point}</strong>
                    </div>
                    <div class="charge-section">
                        {/* <input type="text" class="number-input" value={chargePoint} placeholder={MIN_CHARGE_POINT} onChange={handleChargePointInput} /> */}
                        <div class="input-colgroup">
                            <select onChange={handleChargeOptionChange} value={selectedChargeOption.value}>
                                {CHARGE_OPTIONS.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                        <button class="charge-btn" onClick={handleChargeBtn}>
                            <i class="fas fa-plus-circle"></i>
                            충전하기
                        </button>
                    </div>
                </div>
            </div>
            <br />
            <div>
                <p class="point_txt" style={{marginBottom: '5px'}}>* 포인트는 회원 홍보게시물 작성시에 사용됩니다.</p>
                <p class="point_txt">* 최소 5,000원부터 1,000원 단위로 충전이 가능합니다.</p>
                <div className="privacy-box" style={{'overflow' : 'auto'}}>
                    -포인트 충전 및 이용 규정-<br />
                    <br />
                    1. 포인트 충전<br />
                    <br />
                    회원은 사이트에서 제공하는 결제수단을 통해 포인트를 충전할 수 있습니다.<br />
                    충전된 포인트는 본 서비스 내 유료 서비스 이용 시 사용됩니다.<br />
                    <br />
                    2. 포인트 이용기간<br />
                    <br />
                    충전된 포인트의 유효기간은 충전일로부터 3개월입니다.<br />
                    유효기간 내 사용하지 않은 포인트는 3개월 경과 시 자동 소멸됩니다.<br />
                    <br />
                    3. 포인트 환불<br />
                    <br />
                    충전된 포인트는 사용하지 않은 포인트에 한하여 환불이 가능합니다.<br />
                    환불 요청 시 결제 수단으로 환불되며, PG사 수수료 및 환불 수수료가 차감될 수 있습니다.<br />
                    포인트를 일부 사용한 경우 사용된 포인트에 해당하는 금액은 환불되지 않습니다.<br />
                </div>
            </div>
            <br />
        </>
    )
}

export default ChargePoint;